export default [
  {
    id: 0,
    slug: 'mikmak_studios',
    name: 'MIKMAK <label style="color: #00bfbd; font-weight: normal;">STUDIOS</label>',
    align: 'left',
    cta: 'Request a quote',
    clickMessage: 'Clicked request quote for MikMak STUDIOS',
    description: '',
    device: {
      color: 'white',
      rotation: '1deg'
    },
    images: {
      default: 'https://s3.amazonaws.com/attach.mikmak.tv/videos/mikmak-sizzle.mp4'
    },
    features: [
      'Content strategy & Creative development',
      'Social media content creation',
      'Full-service video production & post',
      'A/B Video Production Tests'
    ]
  }
]



// WEBPACK FOOTER //
// ./client/store/imports/StudiosProducts.js